"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageKey = void 0;
/**
 * Application-specific storage key constant enum.
 * Keep it all together to avoid, using same key with different purposes.
 * Same consistent keys should be used inside global types declarations.
 */
var StorageKey;
(function (StorageKey) {
    StorageKey["SALESFORCE_ENVIRONMENT"] = "SALESFORCE_ENVIRONMENT";
    StorageKey["SALESFORCE_AUTHORIZATION"] = "SALESFORCE_AUTHORIZATION";
})(StorageKey = exports.StorageKey || (exports.StorageKey = {}));
